import {
  LicencePricing,
  LicencePricingUpdateRequest,
} from "../types/licencePricing.definition";
import {
  getAllLicencePricing,
  updateLicencePricing,
} from "../webclients/licencePricing.client";

export const licencePricingApi = {
  getAll: async (): Promise<LicencePricing[]> => {
    const response = await getAllLicencePricing();
    return response.data;
  },
  update: async (
    id: number,
    data: LicencePricingUpdateRequest
  ): Promise<LicencePricing> => {
    const response = await updateLicencePricing(id, data);
    return response.data;
  },
};
